import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
});

const FilterGroupRow = ({
  children,
  classes,
  className,
  ...rest
}) => {
  return (
    <div className={classNames(classes.root, className)} {...rest}>
      {children}
    </div>
  );
};

FilterGroupRow.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

FilterGroupRow.defaultProps = {
  className: '',
};

export default withStyles(styles)(FilterGroupRow);
